// extracted by mini-css-extract-plugin
export default {"text":"normal_text__gLFzE","container":"normal_container__YZs3x","cancel":"normal_cancel__I72K-"};